import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050507]">
      <div className="mx-auto flex max-w-7xl flex-col gap-8 px-6 py-12 md:flex-row md:items-start md:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#F4F1EA] p-1">
              <img src="/logo.png" alt="NAKSRA logo" className="h-full w-full object-contain" />
            </span>
            <span className="font-heading text-xl font-semibold tracking-[0.25em] text-[#F8F9FA]">NAKSRA</span>
          </div>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-[#A1A1AA]">
            Jyotish reports rooted in the 5,000-year-old science of the Nakshatras. No fear. No vagueness. Full methodology, always.
          </p>
        </div>
        <div className="flex gap-16">
          <div className="flex flex-col gap-2 text-sm">
            <span className="text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">Explore</span>
            <Link to="/services" data-testid="footer-services-link" className="text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">Reports & Services</Link>
            <Link to="/blog" data-testid="footer-blog-link" className="text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">Sangha (Community)</Link>
            <Link to="/account" data-testid="footer-account-link" className="text-[#A1A1AA] transition-colors duration-300 hover:text-[#D4AF37]">My Account</Link>
          </div>
          <div className="flex flex-col gap-2 text-sm">
            <span className="text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">Promise</span>
            <span className="text-[#A1A1AA]">Money-back guarantee</span>
            <span className="text-[#A1A1AA]">Astrologer-verified</span>
            <span className="text-[#A1A1AA]">Radical transparency</span>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10 py-5 text-center text-xs text-[#A1A1AA]">
        <div className="mb-3 flex items-center justify-center gap-3">
          <Link to="/privacy" data-testid="footer-gdpr-badge" title="GDPR — Personal Data Privacy Policy">
            <img src="/gdpr.png" alt="GDPR — General Data Protection Regulation" className="h-10 w-10 rounded-full transition-transform duration-300 hover:scale-110" />
          </Link>
          <Link to="/privacy" data-testid="footer-iso-badge" title="ISO 27701 — Personal Data Privacy Policy">
            <img src="/iso.png" alt="ISO 27701 certified" className="h-10 w-10 transition-transform duration-300 hover:scale-110" />
          </Link>
        </div>
        <Link to="/privacy" data-testid="footer-privacy-link" className="transition-colors duration-300 hover:text-[#D4AF37]">
          Personal Data Privacy Policy
        </Link>
      </div>
    </footer>
  );
}
